export function getPlacementCardKey(placement) {
  switch (placement) {
    case 'stb_main_bannar':
      return 'STBMainBanner'
    case 'stb_bannar':
      return 'STBBanner'
    case 'stb_half_bannar':
      return 'STBHalfBanner'
    case 'stb_sidebar_bannar':
      return 'STBSidebarBanner'
    case 'stb_square_bannar':
      return 'STBSquareBanner'
    case 'stb_popup':
      return 'STBPopup'
    case 'stb_thread':
      return 'STBThread'
    case 'stb_s_ad':
      return 'STBSkippable'
    case 'stb_un_ad':
      return 'STBUnskippable'
    case 'app_bannar':
      return 'AppBanner'
    case 'app_detail_bannar':
      return 'AppDetailBanner'
    case 'app_carousel_ad':
      return 'AppCarouselAd'
    case 'app_popup':
      return 'AppPopup'
    case 'app_thread':
      return 'AppThread'
    case 'app_s_ad':
      return 'AppSkippable'
    case 'app_un_ad':
      return 'AppUnskippable'
    default:
      return 'STBBanner'
  }
}
export const getPlacementName = placement => {
  const placementNames = {
    stb_main_bannar: 'TV Main Banner',
    stb_bannar: 'TV Banner',
    stb_half_bannar: 'TV Half Banner',
    stb_sidebar_bannar: 'TV Sidebar Banner',
    stb_square_bannar: 'TV Square Banner',
    stb_popup: 'TV Popup',
    stb_thread: 'TV Thread',
    stb_s_ad: 'TV Skippable Ad',
    stb_un_ad: 'TV Unskippable Ad',
    app_bannar: 'App Banner',
    app_detail_bannar: 'App Detail Banner',
    app_carousel_ad: 'App Carousel Ad',
    app_popup: 'App Popup',
    app_thread: 'App Thread',
    app_s_ad: 'App Skippable Ad',
    app_un_ad: 'App Unskippable Ad'
  }
  return placementNames[placement] ? placementNames[placement] : 'TV Banner'
}
